import { render, staticRenderFns } from "./QaCategoryList.vue?vue&type=template&id=13aa8dbd&scoped=true"
import script from "./QaCategoryList.vue?vue&type=script&lang=js"
export * from "./QaCategoryList.vue?vue&type=script&lang=js"
import style0 from "./QaCategoryList.vue?vue&type=style&index=0&id=13aa8dbd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa8dbd",
  null
  
)

export default component.exports